import { render, staticRenderFns } from "./CreateDocumentTypes.vue?vue&type=template&id=337f1ab5&scoped=true"
import script from "./CreateDocumentTypes.vue?vue&type=script&lang=js"
export * from "./CreateDocumentTypes.vue?vue&type=script&lang=js"
import style0 from "./CreateDocumentTypes.vue?vue&type=style&index=0&id=337f1ab5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337f1ab5",
  null
  
)

export default component.exports